import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const getBadWarehouseBins = {
  name: "getBadWarehouseBins" as const,
  input: z.object({
    crdbLocationId: locationIdFormat.schema,
    limit: z.number().optional().default(10_000),
  }),
  output: z.object({
    summary: z.object({
      totalGroups: z.number(),
      totalLineItems: z.number(),
      itemsWithCoordinates: z.number(),
      itemsWithoutCoordinates: z.number(),
      itemsWithBinNotMapped: z.number(),
      itemsWithNoBin: z.number(),
    }),
    badBins: z.array(
      z.object({
        productId: z.string(),
        variantId: z.string(),
        provider: z.string(),
        originalBin: z.string(),
        parsedBin: z.string(),
        secondaryBins: z.array(z.string()),
        goodBins: z.array(z.string()),
        badBins: z.array(z.string()),
        fulfillmentGroupCount: z.number(),
        fulfillmentGroupIds: z.array(z.string()),
        similarBins: z.array(
          z.object({ bin: z.string(), distance: z.number() }),
        ),
      }),
    ),
  }),
};
